<template>
    <div class="shatter-column-chart">
        <app-sub-title :text="title" />
        <div class="shatter-pie-chart__pie">
            <GChart
                type="ColumnChart"
                :data="chartData"
                :options="chartOptions"
            />
        </div>
        <div class="shatter-column-chart__table" v-if="showDataTable">
            <GChart type="Table" :data="tableData" :options="tableOptions" />
        </div>
    </div>
</template>
<script>
import { GChart } from 'vue-google-charts'
export default {
    components: {
        GChart,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        chartData: {
            type: Array,
            default: [],
        },
        showDataTable: {
            type: Boolean,
            default: true,
        },
        small: {
            type: Boolean,
            default: false,
        },
        showLegends: {
            type: Boolean,
            default: true,
        },
        width: {
            type: Number,
            default: 500,
        },
        height: {
            type: Number,
            default: 300,
        },
        tableIndicator: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            chartOptions: {
                is3D: true,
                width: 500,
                height: 300,
                legend: {
                    position: 'right',
                    alignment: 'center',
                },
            },
            tableOptions: {
                sort: true,
            },
        }
    },
    computed: {
        tableData() {
            if (!this.chartData.length) return []

            if (!this.tableIndicator) return this.chartData

            const header = this.chartData[0].concat('Indicador')
            const tableData = [header]
            let total = 0
            this.chartData.map((row, index) => {
                if (index === 0) return
                total = total + row[1]
            })
            let indicator = 0
            for (let i = 1; i < this.chartData.length; i++) {
                indicator = _.round((this.chartData[i][1] / total) * 100, 1)
                tableData.push(
                    this.chartData[i].concat({
                        v: indicator,
                        f: `${indicator}%`,
                    })
                )
            }
            return tableData
        },
    },
    created() {
        this.chartOptions.width = this.width
        this.chartOptions.height = this.height
        if (this.small) {
            this.chartOptions.width = 300
            this.chartOptions.height = 150
        }
        if (!this.showLegends) {
            this.chartOptions.legend = { position: 'none' }
        }
    },
}
</script>
<style scoped>
.shatter-column-chart {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>
